export const setCookie = (name, value = true, days = 365, path = '/') => {
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=${path}`
}

export const getCookie = name => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
  if (match) {
    return match[2]
  }
}
